import { IAppState } from "../index";

export const getUsers = (state: IAppState) => state.users.users;
export const getIsRequestingUsers = (state: IAppState) => state.users.requestingUsers;
export const getRequestingUsersError = (state: IAppState) => state.users.requestingUsersError;
